export enum ManagementTypes {
  GET_SUMMARY_REQUEST = '@management/GET_SUMMARY_REQUEST',
  GET_SUMMARY_SUCCESS = '@management/GET_SUMMARY_SUCCESS',
  GET_SUMMARY_FAILURE = '@management/GET_SUMMARY_FAILURE',
  GET_BIDDING_SUMMARY_REQUEST = '@management/GET_BIDDING_REQUEST',
  GET_BIDDING_SUMMARY_SUCCESS = '@management/GET_BIDDING_SUCCESS',
  GET_BIDDING_SUMMARY_FAILURE = '@management/GET_BIDDING_FAILURE',
  GET_CALENDAR_EVENTS_REQUEST = '@management/GET_CALENDAR_EVENTS_REQUEST',
  GET_CALENDAR_EVENTS_SUCCESS = '@management/GET_CALENDAR_EVENTS_SUCCESS',
  GET_CALENDAR_EVENTS_FAILURE = '@management/GET_CALENDAR_EVENTS_FAILURE',
  GET_MANAGED_REQUEST = '@management/GET_MANAGED_REQUEST',
  GET_MANAGED_SUCCESS = '@management/GET_MANAGED_SUCCESS',
  GET_MANAGED_FAILURE = '@management/GET_MANAGED_FAILURE',
  GET_TASKS_REQUEST = '@management/GET_TASKS_REQUEST',
  GET_TASKS_SUCCESS = '@management/GET_TASKS_SUCCESS',
  GET_TASKS_FAILURE = '@management/GET_TASKS_FAILURE',
  GET_BIDDING_TIMELINE_REQUEST = '@management/GET_BIDDING_TIMELINE_REQUEST',
  GET_BIDDING_TIMELINE_SUCCESS = '@management/GET_BIDDING_TIMELINE_SUCCESS',
  GET_BIDDING_TIMELINE_FAILURE = '@management/GET_BIDDING_TIMELINE_FAILURE',
  GET_TASK_BY_ID_REQUEST = '@management/GET_TASK_BY_ID_REQUEST',
  GET_TASK_BY_ID_SUCCESS = '@management/GET_TASK_BY_ID_SUCCESS',
  GET_TASK_BY_ID_FAILURE = '@management/GET_TASK_BY_ID_FAILURE',
  CLEAR_MODAL_TASK = '@management/CLEAR_MODAL_TASK',
  CREATE_MANAGED_REQUEST = '@management/CREATE_MANAGED_REQUEST',
  CREATE_MANAGED_SUCCESS = '@management/CREATE_MANAGED_SUCCESS',
  CREATE_MANAGED_FAILURE = '@management/CREATE_MANAGED_FAILURE',
  DELETE_MANAGED_REQUEST = '@management/DELETE_MANAGED_REQUEST',
  DELETE_MANAGED_SUCCESS = '@management/DELETE_MANAGED_SUCCESS',
  DELETE_MANAGED_FAILURE = '@management/DELETE_MANAGED_FAILURE',
  DELETE_MANAGED_BATCH_REQUEST = '@management/DELETE_MANAGED_BATCH_REQUEST',
  DELETE_MANAGED_BATCH_SUCCESS = '@management/DELETE_MANAGED_BATCH_SUCCESS',
  DELETE_MANAGED_BATCH_FAILURE = '@management/DELETE_MANAGED_BATCH_FAILURE',
  DELETE_TASKS_BATCH_REQUEST = '@management/DELETE_TASKS_BATCH_REQUEST',
  DELETE_TASKS_BATCH_SUCCESS = '@management/DELETE_TASKS_BATCH_SUCCESS',
  DELETE_TASKS_BATCH_FAILURE = '@management/DELETE_TASKS_BATCH_FAILURE',
  DELETE_PROGRESS_BATCH_REQUEST = '@management/DELETE_PROGRESS_BATCH_REQUEST',
  DELETE_PROGRESS_BATCH_SUCCESS = '@management/DELETE_PROGRESS_BATCH_SUCCESS',
  DELETE_PROGRESS_BATCH_FAILURE = '@management/DELETE_PROGRESS_BATCH_FAILURE',
  REACTIVATE_MANAGED_BATCH_REQUEST = '@management/REACTIVATE_MANAGED_BATCH_REQUEST',
  REACTIVATE_MANAGED_BATCH_SUCCESS = '@management/REACTIVATE_MANAGED_BATCH_SUCCESS',
  REACTIVATE_MANAGED_BATCH_FAILURE = '@management/REACTIVATE_MANAGED_BATCH_FAILURE',
  FINISH_MANAGED_BATCH_REQUEST = '@management/FINISH_MANAGED_BATCH_REQUEST',
  FINISH_MANAGED_BATCH_SUCCESS = '@management/FINISH_MANAGED_BATCH_SUCCESS',
  FINISH_MANAGED_BATCH_FAILURE = '@management/FINISH_MANAGED_BATCH_FAILURE',
  UPDATE_TASKS_STATUS_BATCH_REQUEST = '@management/UPDATE_TASKS_STATUS_BATCH_REQUEST',
  UPDATE_TASKS_STATUS_BATCH_SUCCESS = '@management/UPDATE_TASKS_STATUS_BATCH_SUCCESS',
  UPDATE_TASKS_STATUS_BATCH_FAILURE = '@management/UPDATE_TASKS_STATUS_BATCH_FAILURE',
  MARK_READ_PROGRESS_BATCH_REQUEST = '@management/MARK_READ_PROGRESS_BATCH_REQUEST',
  MARK_READ_PROGRESS_BATCH_SUCCESS = '@management/MARK_READ_PROGRESS_BATCH_SUCCESS',
  MARK_READ_PROGRESS_BATCH_FAILURE = '@management/MARK_READ_PROGRESS_BATCH_FAILURE',
  MARK_UNREAD_PROGRESS_BATCH_REQUEST = '@management/MARK_UNREAD_PROGRESS_BATCH_REQUEST',
  MARK_UNREAD_PROGRESS_BATCH_SUCCESS = '@management/MARK_UNREAD_PROGRESS_BATCH_SUCCESS',
  MARK_UNREAD_PROGRESS_BATCH_FAILURE = '@management/MARK_UNREAD_PROGRESS_BATCH_FAILURE',
  CREATE_TASKS_REQUEST = '@management/CREATE_TASKS_REQUEST',
  CREATE_TASKS_SUCCESS = '@management/CREATE_TASKS_SUCCESS',
  CREATE_TASKS_FAILURE = '@management/CREATE_TASKS_FAILURE',
  UPDATE_TASKS_REQUEST = '@management/UPDATE_TASKS_REQUEST',
  UPDATE_TASKS_SUCCESS = '@management/UPDATE_TASKS_SUCCESS',
  UPDATE_TASKS_FAILURE = '@management/UPDATE_TASKS_FAILURE',
  DELETE_TASK_REQUEST = '@management/DELETE_TASK_REQUEST',
  DELETE_TASK_SUCCESS = '@management/DELETE_TASK_SUCCESS',
  DELETE_TASK_FAILURE = '@management/DELETE_TASK_FAILURE',
  UPDATE_SELECTED_FEATURE = '@management/UPDATE_SELECTED_FEATURE',
  HANDLE_FILTER_BY = '@management/HANDLE_FILTER_BY',
  HANDLE_ORDER = '@management/HANDLE_ORDER',
  DELETE_TASK_COMMENT_REQUEST = '@management/DELETE_TASK_COMMENT_REQUEST',
  DELETE_TASK_COMMENT_SUCCESS = '@management/DELETE_TASK_COMMENT_SUCCESS',
  DELETE_TASK_COMMENT_FAILURE = '@management/DELETE_TASK_COMMENT_FAILURE',
  CREATE_TASK_COMMENT_REQUEST = '@management/CREATE_TASK_COMMENT_REQUEST',
  CREATE_TASK_COMMENT_SUCCESS = '@management/CREATE_TASK_COMMENT_SUCCESS',
  CREATE_TASK_COMMENT_FAILURE = '@management/CREATE_TASK_COMMENT_FAILURE',
  CREATE_PROGRESS_COMMENT_REQUEST = '@management/CREATE_PROGRESS_COMMENT_REQUEST',
  CREATE_PROGRESS_COMMENT_SUCCESS = '@management/CREATE_PROGRESS_COMMENT_SUCCESS',
  CREATE_PROGRESS_COMMENT_FAILURE = '@management/CREATE_PROGRESS_COMMENT_FAILURE',
  CREATE_TASK_ATTACHMENT_REQUEST = '@management/CREATE_TASK_ATTACHMENT_REQUEST',
  CREATE_TASK_ATTACHMENT_SUCCESS = '@management/CREATE_TASK_ATTACHMENT_SUCCESS',
  CREATE_TASK_ATTACHMENT_FAILURE = '@management/CREATE_TASK_ATTACHMENT_FAILURE',
  CREATE_PROGRESS_ATTACHMENT_REQUEST = '@management/CREATE_PROGRESS_ATTACHMENT_REQUEST',
  CREATE_PROGRESS_ATTACHMENT_SUCCESS = '@management/CREATE_PROGRESS_ATTACHMENT_SUCCESS',
  CREATE_PROGRESS_ATTACHMENT_FAILURE = '@management/CREATE_PROGRESS_ATTACHMENT_FAILURE',
  DELETE_TASK_ATTACHMENT_REQUEST = '@management/DELETE_TASK_ATTACHMENT_REQUEST',
  DELETE_TASK_ATTACHMENT_SUCCESS = '@management/DELETE_TASK_ATTACHMENT_SUCCESS',
  DELETE_TASK_ATTACHMENT_FAILURE = '@management/DELETE_TASK_ATTACHMENT_FAILURE',
  GET_NOTIFICATION_PROGRESS_REQUEST = '@management/GET_NOTIFICATION_PROGRESS_REQUEST',
  GET_NOTIFICATION_PROGRESS_SUCCESS = '@management/GET_NOTIFICATION_PROGRESS_SUCCESS',
  GET_NOTIFICATION_PROGRESS_FAILURE = '@management/GET_NOTIFICATION_PROGRESS_FAILURE',
  CREATE_PROGRESS_REQUEST = '@management/CREATE_PROGRESS_REQUEST',
  CREATE_PROGRESS_SUCCESS = '@management/CREATE_PROGRESS_SUCCESS',
  CREATE_PROGRESS_FAILURE = '@management/CREATE_PROGRESS_FAILURE',
  UPDATE_PROGRESS_REQUEST = '@management/UPDATE_PROGRESS_REQUEST',
  UPDATE_PROGRESS_SUCCESS = '@management/UPDATE_PROGRESS_SUCCESS',
  UPDATE_PROGRESS_FAILURE = '@management/UPDATE_PROGRESS_FAILURE',
  DELETE_PROGRESS_REQUEST = '@management/DELETE_PROGRESS_REQUEST',
  DELETE_PROGRESS_SUCCESS = '@management/DELETE_PROGRESS_SUCCESS',
  DELETE_PROGRESS_FAILURE = '@management/DELETE_PROGRESS_FAILURE',
  UPDATE_NOTIFICATION_PROGRESS_REQUEST = '@management/UPDATE_NOTIFICATION_PROGRESS_REQUEST',
  UPDATE_NOTIFICATION_PROGRESS_SUCCESS = '@management/UPDATE_NOTIFICATION_PROGRESS_SUCCESS',
  UPDATE_NOTIFICATION_PROGRESS_FAILURE = '@management/UPDATE_NOTIFICATION_PROGRESS_FAILURE',
  GET_FINISHED_REQUEST = '@management/GET_FINISHED_REQUEST',
  GET_FINISHED_SUCCESS = '@management/GET_FINISHED_SUCCESS',
  GET_FINISHED_FAILURE = '@management/GET_FINISHED_FAILURE',
  FINISH_MANAGED_REQUEST = '@management/FINISH_MANAGED_REQUEST',
  FINISH_MANAGED_SUCCESS = '@management/FINISH_MANAGED_SUCCESS',
  FINISH_MANAGED_FAILURE = '@management/FINISH_MANAGED_FAILURE',
  REACTIVATE_MANAGED_REQUEST = '@management/REACTIVATE_MANAGED_REQUEST',
  REACTIVATE_MANAGED_SUCCESS = '@management/REACTIVATE_MANAGED_SUCCESS',
  REACTIVATE_MANAGED_FAILURE = '@management/REACTIVATE_MANAGED_FAILURE',
  GET_MANAGEMENT_ATTACHMENTS_REQUEST = '@management/GET_MANAGEMENT_ATTACHMENTS_REQUEST',
  GET_MANAGEMENT_ATTACHMENTS_SUCCESS = '@management/GET_MANAGEMENT_ATTACHMENTS_SUCCESS',
  GET_MANAGEMENT_ATTACHMENTS_FAILURE = '@management/GET_MANAGEMENT_ATTACHMENTS_FAILURE',
  CREATE_MANAGEMENT_ATTACHMENTS_REQUEST = '@management/CREATE_MANAGEMENT_ATTACHMENTS_REQUEST',
  CREATE_MANAGEMENT_ATTACHMENTS_SUCCESS = '@management/CREATE_MANAGEMENT_ATTACHMENTS_SUCCESS',
  CREATE_MANAGEMENT_ATTACHMENTS_FAILURE = '@management/CREATE_MANAGEMENT_ATTACHMENTS_FAILURE',
  DELETE_MANAGEMENT_ATTACHMENTS_REQUEST = '@management/DELETE_MANAGEMENT_ATTACHMENTS_REQUEST',
  DELETE_MANAGEMENT_ATTACHMENTS_SUCCESS = '@management/DELETE_MANAGEMENT_ATTACHMENTS_SUCCESS',
  DELETE_MANAGEMENT_ATTACHMENTS_FAILURE = '@management/DELETE_MANAGEMENT_ATTACHMENTS_FAILURE',
  GET_MANAGEMENT_PREFERENCES_REQUEST = '@management/GET_MANAGEMENT_PREFERENCES_REQUEST',
  GET_MANAGEMENT_PREFERENCES_SUCCESS = '@management/GET_MANAGEMENT_PREFERENCES_SUCCESS',
  GET_MANAGEMENT_PREFERENCES_FAILURE = '@management/GET_MANAGEMENT_PREFERENCES_FAILURE',
  UPDATE_MANAGEMENT_PREFERENCES_REQUEST = '@management/UPDATE_MANAGEMENT_PREFERENCES_REQUEST',
  UPDATE_MANAGEMENT_PREFERENCES_SUCCESS = '@management/UPDATE_MANAGEMENT_PREFERENCES_SUCCESS',
  UPDATE_MANAGEMENT_PREFERENCES_FAILURE = '@management/UPDATE_MANAGEMENT_PREFERENCES_FAILURE',
  GET_BIDDING_OVERVIEW_REQUEST = '@management/GET_BIDDING_OVERVIEW_REQUEST',
  GET_BIDDING_OVERVIEW_SUCCESS = '@management/GET_BIDDING_OVERVIEW_SUCCESS',
  GET_BIDDING_OVERVIEW_FAILURE = '@management/GET_BIDDING_OVERVIEW_FAILURE',
  GET_MANAGEMENT_MEMBERS_REQUEST = '@management/GET_MANAGEMENT_MEMBERS_REQUEST',
  GET_MANAGEMENT_MEMBERS_SUCCESS = '@management/GET_MANAGEMENT_MEMBERS_SUCCESS',
  GET_MANAGEMENT_MEMBERS_FAILURE = '@management/GET_MANAGEMENT_MEMBERS_FAILURE',
  UPDATE_CREATE_MANAGEMENT_ATTACHMENTS_STORE = '@management/UPDATE_CREATE_MANAGEMENT_ATTACHMENTS_STORE',
  UPDATE_STORE_FIELDS = '@management/UPDATE_STORE_FIELDS',
}

export type FeatureType =
  | 'tasks'
  | 'comments'
  | 'attachments'
  | 'documents'
  | 'monitoring'
  | 'results';
export interface ProgressOverviewData {
  title: string;
  deadline: string;
  id: number;
}
export interface AnotacoesData {
  pendencias: string[];
  pontos_atencao: string[];
  decisoes: string[];
}
export interface TaskGroup {
  count: number;
  titles: string[];
}
export interface TaskSummary {
  atrasadas: TaskGroup;
  hoje: TaskGroup;
  concluidas: TaskGroup;
}
export interface TasksData {
  suas: TaskSummary;
  equipe: TaskSummary;
}
export interface OverviewData {
  andamentos: Array<ProgressOverviewData>;
  situacao_atual: string;
  chat_resumo?: string;
  chat_principais?: any[];
  anotacoes?: AnotacoesData;
  tasks?: TasksData;
}

export interface TotalTasksData {
  late: number;
  today: number;
  future: number;
  finished: number;
}

export interface TotalProgressData {
  read: number;
  unread: number;
}

export interface BiddingSummaryFinished {
  management_finished_status: string;
  amount: number | null;
  comments: string | null;
  created_at: string;
}

export interface CalendarEvent {
  id: string;
  type: 'bidding' | 'task' | 'progress';
  date: string;
  title: string | null;
  description: string | null;
  bidding_id: number;
  finished?: boolean;
}
export interface TotalFinishedData {
  winner: number;
  partial_winner: number;
  lost: number;
  declined: number;
  revoked: number;
  failed: number;
  cancelled: number;
}

export interface PublicBodyTypes {
  nome: string;
}

export interface BiddingData {
  id: number;
  bidding_id: string;
  edital: string;
  public_body: PublicBodyTypes;
  orgao_estado: string;
  orgao_cidade: string;
}

export interface ManagedBy {
  user_id: number;
  name: string;
}

export interface ManagedData {
  id: number;
  edital: string;
  datahora_prazo: string;
  datahora_abertura: string;
  datahora_retirada: string;
  datahora_visita: string;
  datahora_documento: string;
  data_validade: string;
  objeto: string;
  public_body: PublicBodyTypes;
  total_managed_opened_tasks: number;
  managed: boolean;
  managed_by_others: boolean;
  orgao_estado: string;
  orgao_cidade: string;
  tipo_agrupamento_id: number;
  managers: Array<ManagedBy>;
}
export interface FinishedData {
  id: number;
  management_bidding_finished: {
    created_at: string;
    amount: number;
    comments: string;
  };
  edital: string;
  datahora_prazo: string;
  datahora_abertura: string;
  datahora_retirada: string;
  datahora_visita: string;
  datahora_documento: string;
  data_validade: string;
  objeto: string;
  public_body: PublicBodyTypes;
  total_managed_opened_tasks: number;
  managed: boolean;
  managed_by_others: boolean;
  orgao_estado: string;
  orgao_cidade: string;
  management_finished_status: string;
  tipo_agrupamento_id: number;
  managers: Array<ManagedBy>;
}

export interface ContactClientData {
  id: number;
  nome: string;
}

export interface TaskEventData {
  id: number;
  description: string;
  created_at: string;
  contact_client: ContactClientData;
}

export interface BiddingAttachmentsData {
  created_at: string;
  description: string;
  referer: string;
  referer_name: string;
  filename: string;
  id: number;
  parsed_url: string;
}

export interface ResponsibleData {
  id: number;
  nome: string;
}

export interface TaskData {
  id: number;
  bidding_id: number;
  client_id: number;
  task_type_id: string;
  created_by_id: number;
  responsible_id: number;
  title: string;
  description: string;
  deadline: string;
  status_task_id: string;
  created_at: string;
  updated_at: string;
  finished_date: string | null;
  bidding: BiddingData;
  responsible: ResponsibleData;
  bidding_attachments: Array<BiddingAttachmentsData>;
  task_event_histories: Array<TaskEventData>;
  task_event_comments: Array<TaskEventData>;
}

export interface ProgressData {
  id: number;
  bidding_id: number;
  client_id: number;
  task_type_id: string;
  created_by_id: number;
  responsible_id: number;
  title: string;
  description: string;
  deadline: string;
  status_task_id: string;
  created_at: string;
  updated_at: string;
  finished_date: string | null;
  bidding: BiddingData;
  responsible: ResponsibleData;
  bidding_attachments: Array<BiddingAttachmentsData>;
  task_event_histories: Array<TaskEventData>;
  task_event_comments: Array<TaskEventData>;
}

export interface NotificationProgressData {
  id: number;
  user_id: number;
  read: boolean;
  created_at: string;
  task_id: number;
  bidding_id: number;
  notification_reason_id: number;
  progress: ProgressData;
  bidding: BiddingData;
}

export interface ManagementMember {
  id: number;
  nome: string;
}

export interface ManagementMembers {
  companyId: number;
  active: Array<ManagementMember>;
  inactive: Array<ManagementMember>;
}

export interface ManagementData {
  management_summary: {
    total_favorites: number;
    total_managed: number;
    total_finished: TotalFinishedData;
    total_tasks: TotalTasksData;
    total_progress: TotalProgressData;
  };
  bidding_summary: {
    [id: string]: {
      total_tasks: TotalTasksData;
      total_progress: TotalProgressData;
      is_managed?: boolean;
      is_managed_by_me?: boolean;
      total_managed_opened_tasks?: number;
      finished?: BiddingSummaryFinished | null;
    };
  };
  calendar_events: Array<CalendarEvent>;
  managed: Array<ManagedData>;
  managed_total_entries: number;
  finished: Array<FinishedData>;
  finished_total_entries: number;
  tasks: Array<TaskData>;
  tasks_total_entries: number;
  // Slice separado para a visão de detalhe de uma licitação (TasksPage com prop
  // `bidding`), para não sobrescrever a lista geral `tasks` da aba Gerenciar.
  bidding_tasks: Array<TaskData>;
  bidding_tasks_total_entries: number;
  timeline_tasks: Array<TaskData>;
  timeline_progress: Array<NotificationProgressData>;
  modal_task: TaskData | null;
  notification_progress: Array<NotificationProgressData>;
  notification_progress_total_entries: number;
  progress: Array<ProgressData>;
  selected_feature: 'favorites' | 'managed' | 'finished' | 'tasks' | 'progress' | 'calendar';
  filtered_by: string;
  ordered_by: string;
  order_direction: string;
  overview: OverviewData | null;
  overview_last_updated: number | null;
  overview_bidding_id: number | string | null;
  members: ManagementMembers | null;
}

export interface ManagementAttachmentsData {
  [key: string]: Array<BiddingAttachmentsData>;
}

export interface ManagementPreferencesData {
  id: number;
  user_id: number;
  client_id: number;
  email_notification: boolean;
  push_notification: boolean;
  whatsapp_notification: boolean;
  clarification_notification: boolean;
  notice_notification: boolean;
  impugnment_notification: boolean;
  appeal_notification: boolean;
  status_notification: boolean;
  result_notification: boolean;
}

export interface RequestStatus {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface RequestState {
  management_summary: RequestStatus;
  bidding_summary: RequestStatus;
  calendar_events: RequestStatus;
  managed: RequestStatus;
  finished: RequestStatus;
  get_tasks: RequestStatus;
  get_bidding_timeline: RequestStatus;
  get_task_by_id: RequestStatus;
  create_tasks: RequestStatus;
  update_tasks: RequestStatus;
  delete_task: RequestStatus;
  create_task_comment: RequestStatus;
  delete_task_comment: RequestStatus;
  create_progress_comment: RequestStatus;
  create_task_attachment: RequestStatus;
  delete_task_attachment: RequestStatus;
  create_progress_attachment: RequestStatus;
  get_notification_progress: RequestStatus;
  update_notification_progress: RequestStatus;
  create_progress: RequestStatus;
  update_progress: RequestStatus;
  delete_progress: RequestStatus;
  finish_managed: RequestStatus;
  finish_managed_batch: RequestStatus;
  reactivate_managed: RequestStatus;
  update_tasks_status_batch: RequestStatus;
  mark_read_progress_batch: RequestStatus;
  mark_unread_progress_batch: RequestStatus;
  get_bidding_documents_attachments: RequestStatus;
  get_management_preferences: RequestStatus;
  update_management_preferences: RequestStatus;
  get_bidding_overview: RequestStatus;
  get_management_members: RequestStatus;
}
export interface RequestManagementAttachmentsState {
  get_management_attachments: RequestStatus;
  create_management_attachements: {
    [key: string]: {
      loading: boolean;
      loaded: boolean;
      error: boolean;
    };
  };
  delete_management_attachements: RequestStatus;
}

export interface ManagementState {
  readonly management_attachments: ManagementAttachmentsData;
  readonly management: ManagementData;
  readonly management_preferences: ManagementPreferencesData;
  readonly request: RequestState;
  readonly request_management_attachments: RequestManagementAttachmentsState;
}
